import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, defineAsyncComponent } from 'vue'

// Helpers
import {
  DOMAINS_NAMES,
  getDomainUrl,
  MANAGE_BOOKING_URLS,
} from '@white-label-helper/switch-app';

// Types
import type { Partners } from '@white-label-types/partners-api';


export default /*#__PURE__*/_defineComponent({
  __name: 'navbar-partner-link',
  props: {
  partnerName: {
    required: true,
    type: String as PropType<Partners['partner_name']>
  }
},
  setup(__props) {

const props = __props;

// Packages


const IconLink = defineAsyncComponent(() => import('@white-label-icon/icon-link'));

const url = computed(() => {
  /** Send the customer to the search results page */
  const domainUrl = getDomainUrl(DOMAINS_NAMES.ECOMMERCE);
  return domainUrl
    ? domainUrl.concat(MANAGE_BOOKING_URLS.BOOKING_SEARCH)
    : '/'
})

return { __sfc: true,props, IconLink, url }
}

})